import type { ReactNode } from "react";
import { TotpAdminReset, TotpEnroll, TotpPolicyForm } from "@mops/totp-ui-v2";
import type { TotpPolicy, TotpSetup } from "@mops/totp-ui-v2";
// 공통 조각의 CSS — 공통 v3 의 tokens.css · components.css 뒤에 실려야 한다(main.tsx 가 그 둘을 먼저 싣는다).
// v2 조각은 v3 어휘(.b-btn · .b-input …)를 그대로 쓰므로 예전의 이름 다리(TotpVocab.css)가 필요 없다.
import "@mops/totp-ui-v2/totp-ui.css";
import "./Auth.css";
import { tx } from "../i18n";

/* ══ 2단계 인증(TOTP)의 자리 — 시안 공통 ①③④(Figma 91-2 · 92-2 · 92-215) ══
   **안쪽 모양은 공통 `@mops/totp-ui-v2` 그대로**다(hub-mops · mops-code 와 같은 조각). 로그인 2단계 ·
   강제 등록 카드는 카드째 공통(`TotpLoginCard` · `TotpEnrollGate`)이다 — 예전에 여기 있던 그 둘을
   공통으로 올렸다(t-mops-totp-unify). 여기 남은 것은 셸 안 카드(내 계정 · 정책 · 관리자 해제)의 틀이고,
   서버를 부르는 함수는 화면이 넘긴다 — 그래야 패턴 페이지가 상태마다 세울 수 있다. 화면 조각을 b3x-in 에 다시 만들지 않는다(사본이 생기는 길이다). */

export type EnrollFns = {
  onSetup: (password: string) => Promise<TotpSetup>;
  onConfirm: (code: string) => Promise<void>;
  onDisable: (password: string) => Promise<void>;
  onEnrolled?: () => void;
  onDisabled?: () => void;
};

/** 내 계정의 2단계 카드 — 미등록 · 등록 중(QR) · 등록됨 · 정책이 필수(해제 단추 없음) 넷을 안쪽 조각이 그린다. */
export function TotpAccountCard({ enabled, required, fns }: { enabled: boolean; required: boolean; fns: EnrollFns }) {
  return (
    <section className="b-card acctcard">
      <h2 className="b-card-title">{tx("totp.title")}</h2>
      <TotpEnroll enabled={enabled} required={required} {...fns} />
    </section>
  );
}

/** 설정 › 로그인 · 2단계 — 강제 정책. 이 설치 계정으로 들어온 로그인에만 걸린다. */
export function TotpPolicyCard({ saved, onSave }: { saved: TotpPolicy; onSave: (p: TotpPolicy) => Promise<void> }) {
  return (
    <section className="b-card acctcard">
      <h2 className="b-card-title">{tx("totp.policyTitle")}</h2>
      <TotpPolicyForm
        saved={saved}
        onSave={onSave}
        note={tx("totp.policyNote")}
      />
    </section>
  );
}

/** 사용자 표의 펼친 줄 안 — 기기를 잃은 사람을 위한 관리자 해제. */
export function TotpAdminResetCell({ onReset, children }: { onReset: (username: string) => Promise<void>; children?: ReactNode }) {
  return (
    <div className="utable__cell">
      <p className="utable__label">{tx("totp.resetLabel")}</p>
      <TotpAdminReset onReset={onReset} lockoutHint={tx("totp.lockoutHint")} />
      {children}
    </div>
  );
}
